<script setup>
import { DateTime } from 'luxon'
import { computed, ref } from 'vue'
import { humanReadableDuration } from '@/composables/datetime'

const timestamp = defineModel({ type: DateTime, default: null })
defineEmits(['close'])
const interval = ref(1000 * 60)
const timeJumperMenu = ref(false)
const intervals = [
  1000 * 5,
  1000 * 60,
  1000 * 60 * 5,
  1000 * 60 * 10,
  1000 * 60 * 30,
  1000 * 60 * 60,
  1000 * 60 * 60 * 3,
  1000 * 60 * 60 * 6,
  1000 * 60 * 60 * 12,
  1000 * 60 * 60 * 24,
  1000 * 60 * 60 * 24 * 3,
  1000 * 60 * 60 * 24 * 7,
]
const availableIntervals = computed(() => {
  return intervals.map(interval => ({ value: interval, title: humanReadableDuration(interval) }))
})

function jumpForward() {
  timestamp.value = timestamp.value.plus({ millisecond: interval.value })
}

function jumpBackward() {
  timestamp.value = timestamp.value.minus({ millisecond: interval.value })
}
</script>

<template>
  <v-layout-card
    variant="elevated"
    class="position-absolute py-2 d-flex flex-column ga-1"
    style="bottom: 16px; right: 50%; transform: translate(50%); z-index: 10"
  >
    <div class="d-flex align-center justify-space-between">
      <v-card-subtitle class="px-0">
        <v-icon
          icon="mdi-clock-start"
          class="me-1"
        />
        {{ $t('canvas.time_jump') }}
      </v-card-subtitle>
      <v-btn
        class="rounded-pill"
        icon
        size="x-small"
        variant="plain"
        @click="$emit('close')"
      >
        <v-icon
          icon="mdi-close"
          size="large"
        />
      </v-btn>
    </div>

    <v-divider class="mb-2" />

    <div
      class="d-flex align-center justify-center ga-2"
      style="min-width: 250px"
    >
      <v-btn
        class="rounded-pill"
        icon
        size="small"
        variant="text"
        @click="jumpBackward"
      >
        <v-icon
          icon="mdi-skip-backward"
          size="large"
        />
      </v-btn>
      <v-btn
        class="rounded-pill flex-fill"
        :append-icon="timeJumperMenu ? 'mdi-menu-up' : 'mdi-menu-down'"
        variant="outlined"
      >
        {{ humanReadableDuration(interval) }}
        <v-menu
          v-model="timeJumperMenu"
          activator="parent"
        >
          <v-list>
            <v-list-item
              v-for="i in availableIntervals"
              :key="i.value"
              :value="i.value"
              :title="i.title"
              @click="() => (interval = i.value)"
            />
          </v-list>
        </v-menu>
      </v-btn>
      <v-btn
        class="rounded-pill"
        icon
        size="small"
        variant="text"
        @click="jumpForward"
      >
        <v-icon
          icon="mdi-skip-forward"
          size="large"
        />
      </v-btn>
    </div>
  </v-layout-card>
</template>

<style scoped></style>
